<!-- Correlation ID = {{ correlationId }} -->

<router-outlet *ngIf="(licenseState$ | async).active"></router-outlet>
<app-license-blocker *ngIf="!(licenseState$ | async).active"></app-license-blocker>
